import { Dashboard } from './dashboard_en.js';
import { Tests } from './tests_en.js';

const en = {
    translations: {
        Dashboard,
        Tests,
    },
};

export default en;
